class RecoverPage {
    init() {
        this.view = new Vue({
            el: "#reset_form",
            data() {
                return {
                    username: "",
                    get isSubuser() {
                        return this.username.match(/@.*\//)
                    },
                }
            },
            mounted() {
                if(window.sessionStorage && sessionStorage.username) {
                    this.username = sessionStorage.username
                    delete sessionStorage.username
                }
            }
        })
    }
}
